import { FormKey, FormTask } from './form-key';
import { TaskStatus } from './task-status.enum';
import { ITask } from '../types/task.interface';

const formKeyPredicate = (formKey: ITask['formKey']) => (task: ITask) => formKey === task?.formKey;

export const addressReviewTaskPredicate = formKeyPredicate(FormTask.AddressReview);
export const buildFormTaskPredicate = formKeyPredicate(FormTask.BuildForm);
export const reviewFormTaskPredicate = formKeyPredicate(FormTask.ReviewForm);
export const viewReviewTaskPredicate = formKeyPredicate(FormTask.ViewReview);
export const viewCompleteFormTaskPredicate = formKeyPredicate(FormTask.ViewCompleteForm);

const actionableFormKeys: FormKey[] = [
  FormTask.AddressReview,
  FormTask.BuildForm,
  FormTask.ViewReview,
  FormTask.ViewCompleteForm,
];

export const openTaskPredicate = (task: ITask) => task.status === TaskStatus.Open;
export const actionableTaskPredicate = (task: ITask) => task.formKey && actionableFormKeys.includes(task.formKey);
export const reviewableTaskPredicate = (task: ITask, userId?: string) =>
  userId ? task.formKey === FormTask.ReviewForm && task.candidateUsers === userId : false;
